const MOJIBAKE_PATTERN = /(?:Ã.|Â.|â[\u0080-\u00BF])/;

function decodeMojibakeText(value) {
    if (typeof value !== "string" || !MOJIBAKE_PATTERN.test(value)) {
        return value;
    }

    try {
        return decodeURIComponent(escape(value));
    } catch (error) {
        return value;
    }
}

function normalizeMojibake(value) {
    if (Array.isArray(value)) {
        return value.map((item) => normalizeMojibake(item));
    }

    if (value && typeof value === "object") {
        return Object.keys(value).reduce((normalized, key) => {
            normalized[key] = normalizeMojibake(value[key]);
            return normalized;
        }, {});
    }

    return decodeMojibakeText(value);
}

export { decodeMojibakeText, normalizeMojibake };
